$(function() {
    var $fixElement = $('.page-nav');
    var baseFixPoint = $fixElement.offset().top;
    var fixClass = 'is-fixed';
    // 要素が追従する処理
    function fixFunction() {
        var windowScrolltop = $(window).scrollTop();
        if(windowScrolltop >= baseFixPoint) {
            $fixElement.addClass(fixClass);
        } else {
            $fixElement.removeClass(fixClass);
        }
    }
    $(window).on('load scroll', function() {
        fixFunction();
    });
});

$(function(){
  /*swiper スライド*/
  var swiper = new Swiper('.swiper-container2', {
    navigation: { 
      nextEl: '.swiper-button-next2',
      prevEl: '.swiper-button-prev2',
    },
    pagination: {   
      el: '.swiper-pagination2',    
      type: 'bullets',   
      clickable: true,
    },
    loop: true,  
    observer: true,
    observeParents: true,
    /*loopedSlides: 3,*/
    slidesPerView: 1,
		
		/*slideToClickedSlide: true,*/
		spaceBetween: 20,
		/*slidesPerGroup: 1,*/
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 2,
			}
		}
    /*autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },*/
	});
});

$(function(){
  /*swiper スライド ランキング用*/
  var swiper = new Swiper('.swiper-container01', {
    navigation: { 
      nextEl: '.swiper-related-button-next01',
      prevEl: '.swiper-related-button-prev01',
    },
    disabledClass: '.swiper-button-disabled',
    slidesPerView: 2,
		spaceBetween: 32,
		breakpoints: {
			// 768px以上の場合
			768: {
				slidesPerView: 4,
        spaceBetween: 10,
			}
		}
	});
  
});